var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/size-guide/measurement-unit-select.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"o-row c-size-guide__unit\">\n\n    <div class=\"o-row o-column o-extra-small--12 o-medium--8\">\n\n        <h2 class=\"c-size-guide__h2\">\n            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 5, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["size-guide_secondary-header",runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedFit")),"displayName"),runtime.contextOrFrameLookup(context, frame, "selectedUnit")]})]))), env.opts.autoescape);
output += "\n        </h2>\n\n    </div>\n\n    <div class=\"o-row o-column o-extra-small--12 o-medium--4\">\n\n        <fieldset>\n                \n            ";
frame = frame.push();
var t_3 = (lineno = 14, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["sizeGuide.measurementUnits",[]]));
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("unit", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\n                ";
var t_5;
t_5 = (lineno = 16, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["selectedFit.has" + "" + runtime.memberLookup((t_4),"name")]));
frame.set("isAvailable", t_5, true);
if(frame.topLevel) {
context.setVariable("isAvailable", t_5);
}
if(frame.topLevel) {
context.addExport("isAvailable", t_5);
}
output += "\n\n                <div class=\"c-radio-styled c-size-guide__unit-select\">\n\n                    <input type=\"radio\"\n                        class=\"c-radio-styled__radio js-side-guide-measurement-unit-select\"\n                        value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name"), env.opts.autoescape);
output += "\"\n                        name=\"size-guide-measurement-unit\"\n                        id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"slug"), env.opts.autoescape);
output += "\"\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "sizeGuide")),"selectedUnit") == runtime.memberLookup((t_4),"name")) {
output += "checked";
;
}
output += "\n                        ";
if(!runtime.contextOrFrameLookup(context, frame, "isAvailable")) {
output += "disabled";
;
}
output += "\n                    >\n\n                    <label class=\"c-radio-styled__label ";
output += runtime.suppressValue((!runtime.contextOrFrameLookup(context, frame, "isAvailable")?"is-disabled":""), env.opts.autoescape);
output += "\" for=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"slug"), env.opts.autoescape);
output += "\">\n                        ";
output += runtime.suppressValue((lineno = 34, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.memberLookup((t_4),"slug")])), env.opts.autoescape);
output += "\n                    </label>\n\n                </div>\n\n            ";
;
}
}
frame = frame.pop();
output += "\n            \n        </fieldset>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/size-guide/measurement-unit-select.j2"] , dependencies)